import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicantComponent } from './applicant/applicant.component';
import { AuthGuard } from './_core/guards/auth.guard';
import { PraticaComponent } from './pratica/pratica.component';
import { PresentationSheetComponent } from './presentation-sheet/presentation-sheet.component';
import { ScoreComponent } from './score/score.component';
import { CertificateGuard } from './_core/guards/certificate.guard';
import { PraticaDetailComponent } from './pratica-detail/pratica-detail.component';
import { CourtesyPageComponent } from './core/components/courtesy-page/courtesy-page.component';
import { KpiTableComponent } from './_widgets/kpi-table/kpi-table.component';
import { PraticaGuard } from './_core/guards/pratica.guard';
import { ScoreGuard } from './_core/guards/score.guard';
import { AmlScoreComponent } from './aml-score/aml-score.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [CertificateGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.module').then((module) => module.HomeModule),
      },

      {
        path: 'pratica/:idPratica',
        canActivate: [PraticaGuard],
        loadComponent: () =>
          import('./pratica/pratica.component').then((c) => c.PraticaComponent),
        children: [
          {
            path: '',
            redirectTo: 'detail',
            pathMatch: 'full',
          },
          {
            path: 'detail',
            component: PraticaDetailComponent,
            children: [
              { path: '', redirectTo: 'applicant', pathMatch: 'full' },
              {
                path: 'applicant',
                loadComponent: () =>
                  import('./applicant/applicant.component').then(
                    (c) => c.ApplicantComponent
                  ),
              },
              {
                path: 'requests',
                loadChildren: () =>
                  import('./requests/requests.module').then(
                    (module) => module.RequestsModule
                  ),
              },
              {
                path: 'anagraphics',
                loadChildren: () =>
                  import('./anagraphics/anagraphics.module').then(
                    (module) => module.AnagraphicsModule
                  ),
              },
              {
                path: 'score',
                loadComponent: () =>
                  import('./score/score.component').then(
                    (c) => c.ScoreComponent
                  ),
                canActivate: [ScoreGuard],
              },
              {
                path: 'aml-score',
                loadComponent: () =>
                  import('./aml-score/aml-score.component').then(
                    (c) => c.AmlScoreComponent
                  ),
                canActivate: [ScoreGuard],
              },
              {
                path: 'presentation-sheet',
                loadComponent: () =>
                  import(
                    './presentation-sheet/presentation-sheet.component'
                  ).then((c) => c.PresentationSheetComponent),
              },

              {
                path: 'documents',
                loadChildren: () =>
                  import('./documents/documents.module').then(
                    (module) => module.DocumentsModule
                  ),
              },
            ],
          },
          {
            path: 'questionario-qualitativo',
            loadComponent: () =>
              import('./_widgets/kpi-table/kpi-table.component').then(
                (c) => c.KpiTableComponent
              ),
          },
          {
            path: 'credit-score-crif',
            loadComponent: () =>
              import('./_widgets/kpi-table/kpi-table.component').then(
                (c) => c.KpiTableComponent
              ),
          },
          {
            path: 'analisi-andamentale',
            loadComponent: () =>
              import('./_widgets/kpi-table/kpi-table.component').then(
                (c) => c.KpiTableComponent
              ),
          },
          {
            path: 'analisi-bilancio',
            loadComponent: () =>
              import('./_widgets/kpi-table/kpi-table.component').then(
                (c) => c.KpiTableComponent
              ),
          },
          {
            path: 'analisi-garanzie',
            loadComponent: () =>
              import('./_widgets/kpi-table/kpi-table.component').then(
                (c) => c.KpiTableComponent
              ),
          },
          {
            path: 'score-kyc',
            loadComponent: () =>
              import('./_widgets/kpi-table/kpi-table.component').then(
                (c) => c.KpiTableComponent
              ),
          },
        ],
      },
      {
        path: 'employee-id',
        loadChildren: () =>
          import('./employee-id/employee-id.module').then(
            (module) => module.EmployeeIdModule
          ),
      },
    ],
  },
  { path: 'system-not-available', loadComponent: () => CourtesyPageComponent },
  //{ path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
